import { createAsyncThunk } from '@reduxjs/toolkit';
import { IGetServicePaymentsRequest } from 'types';
import { getErrorResponse } from 'utils/helpers';
import { ServicePaymentsService } from 'utils/services';

export const getServicePayments = createAsyncThunk(
	'servicePaymentsSlice/getSingleReceiptsList',
	async (reqBody: IGetServicePaymentsRequest, { rejectWithValue }) => {
		try {
			const { data } = await ServicePaymentsService.getAllServicePayments(reqBody);

			return data;
		} catch (error) {
			return rejectWithValue(getErrorResponse(error));
		}
	}
);
